import Layout from "@/components/feature/Layout";
import Seo from "@/components/feature/Seo";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import Featured from "./components/Featured";
import Trending from "./components/Trending";
import Updates from "./components/Updates";
import Topic from "./components/Topic";
import Testimonials from "./components/Testimonials";
import FaqPreview from "./components/FaqPreview";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "吹雪漫画网",
    description: "专注雪景、冬日、雪国、冰雪、冬物语与雪女传说的冬日题材漫画在线阅读网站",
    url: "https://secretom.github.io/",
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "吹雪漫画网",
    url: "https://secretom.github.io/",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: "https://secretom.github.io/category/dongwuyu?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  },
];

export default function Home() {
  return (
    <Layout>
      <Seo
        title="吹雪漫画网 | 雪景漫画、冬日漫画、雪国冬物语冰雪题材在线看"
        description="想看雪景、冬日、雪国题材漫画？吹雪漫画网收录冰雪物语、冬物语、雪女传说等冷门冬日佳作，高清在线看，分类清晰，点开即读，追更不迷路。"
        keywords="吹雪漫画网,雪景漫画,冬日漫画,雪国漫画,冬物语,冰雪漫画,雪女漫画"
        canonical="https://secretom.github.io/"
        jsonLd={jsonLd}
      />
      <Hero />
      <Categories />
      <Featured />
      <Trending />
      <Updates />
      <Topic />
      <Testimonials />
      <FaqPreview />
    </Layout>
  );
}